export default __webpack_public_path__ + "static/media/switch-horizontal.e74d9ad3.svg";